import React from 'react';
import { FormControl, FormHelperText, Grid } from '@mui/material';
import { StyledSelect } from '../../styled/select.input';
import { StyledMenuItem } from '../../styled/menuItem.input';

export const DropDown = ({ field, design, onChange, value, error, helperText }: any) => {
  const showError = error !== undefined ? true : false;

  return (
    <Grid>
      <FormControl variant='standard' style={{ width: '100%' }}>
        <StyledSelect
          name={field.id}
          value={value !== null ? value : ''}
          onChange={onChange}
          label={field.description}
          design={design}
          error={error !== undefined ? true : false}
        >
          {field.options.map((option: any) => (
            <StyledMenuItem
              design={design}
              key={option.id}
              value={option.value}
            >
              {option.title}
            </StyledMenuItem>
          ))}
        </StyledSelect>
        {showError && <FormHelperText error>{helperText}</FormHelperText>}
      </FormControl>
    </Grid>
  );
};
